import { CollectionMediumEnum, CollectionTypeEnum, } from "../types/Api";
/** Request form for an ISSN at the Czech ISSN centre (National Technical Library). */
export var ISSN_REQUEST_URL = "https://www.techlib.cz/cs/2850-zadost-o-prideleni-issn";
/** ONIX Codetable 150 product form prefix of a printed book (BA, BB, BC, ...). */
var PRINT_FORM_PREFIX = "B";
/** ONIX Codetable 150 product form prefix of a digital (online / downloadable) publication (EA, EB, ...). */
var ELECTRONIC_FORM_PREFIX = "E";
/** The ISSN media the check compares - an ISSN of a physical carrier is neither print nor online. */
var ISSN_MEDIA = [
    CollectionMediumEnum.PRINT,
    CollectionMediumEnum.ONLINE,
];
/** Series first, editions second - the order the warning lists them. */
var COLLECTION_TYPES = [
    CollectionTypeEnum.SERIES,
    CollectionTypeEnum.PUBLISHER_SERIES,
];
/**
 * Whether a product is print or electronic by its ONIX product form, the same convention as the backend
 * (ProductPublicViewMapper): B* = print, E* = electronic.
 */
export var getProductMediumKind = function (product) {
    var _a, _b;
    var form = (_b = (_a = product === null || product === void 0 ? void 0 : product.form) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim().toUpperCase();
    if (!form)
        return null;
    if (form.startsWith(PRINT_FORM_PREFIX))
        return "print";
    if (form.startsWith(ELECTRONIC_FORM_PREFIX))
        return "electronic";
    return null;
};
/**
 * Informative ISSN check of a title (DB-787, NKP #747 note_67884): when the title has both a print and an
 * electronic product, every collection type (Series, editions) whose linked collections carry an ISSN of only
 * one medium (print vs online) is reported, so the publisher can attach the ISSN of the other medium or request
 * one. Collections without an ISSN or of an unknown / physical-carrier medium are not considered. Never a
 * validation - it must not block saving or submitting.
 */
export var findIssnMediumGaps = function (titleCollections, products) {
    var kinds = new Set((products !== null && products !== void 0 ? products : []).map(getProductMediumKind));
    if (!kinds.has("print") || !kinds.has("electronic"))
        return [];
    var collections = (titleCollections !== null && titleCollections !== void 0 ? titleCollections : [])
        .map(function (titleCollection) { return titleCollection === null || titleCollection === void 0 ? void 0 : titleCollection.collection; })
        .filter(function (collection) {
        var _a;
        return !!((_a = collection === null || collection === void 0 ? void 0 : collection.issn) === null || _a === void 0 ? void 0 : _a.trim()) &&
            !!collection.medium &&
            ISSN_MEDIA.includes(collection.medium);
    });
    return COLLECTION_TYPES.flatMap(function (type) {
        var ofType = collections.filter(function (collection) { return collection.type === type; });
        var covered = ISSN_MEDIA.filter(function (medium) {
            return ofType.some(function (collection) { return collection.medium === medium; });
        });
        if (covered.length !== 1)
            return [];
        var coveredMedium = covered[0];
        return [
            {
                type: type,
                coveredMedium: coveredMedium,
                missingMedium: coveredMedium === CollectionMediumEnum.PRINT
                    ? CollectionMediumEnum.ONLINE
                    : CollectionMediumEnum.PRINT,
                collections: ofType,
            },
        ];
    });
};
